// DropDownStyles.js
const dropDownStyles = {
  formControl: {
    // m: 1,
    // minWidth: 120,
    // maxWidth: 200,
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px", // Rounded corners for the input
      "& fieldset": {
        borderColor: "gray",
      },
      "&:hover fieldset": {
        borderColor: "gray", // Border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "gray", // Border color when focused
      },
    },
    "& .MuiSelect-select": {
      padding: "10px 14px",
    }
  },
  select: {
    color: "white", // Set text color of the dropdown
    fontSize: "14px",
    "& .MuiSelect-icon": {
      color: "gray",
    },
  },
};


const menuProps = {
  PaperProps: {
    sx: {
      backgroundColor: "var(--themeShadowColor)", // Set background color of the dropdown
      color: "white", // Set the text color
      fontSize: "14px",
    },
  },
  MenuListProps: {
    sx: {
      "& .MuiMenuItem-root": {
        // Custom hover color
        "&:hover": {
          backgroundColor: "var(--primaryHeading)", // Change hover color
        },
        // Custom selected background color
        "&.Mui-selected": {
          backgroundColor: "var(--primaryHeading)", // Change selected background color
          "&:hover": {
            backgroundColor: "var(--primaryHeading)", // Ensure hover effect on selected item is different
          },
        },
      },
    },
  },
};


export { dropDownStyles, menuProps };